export const initialValuesAddArchitect = {
	firstname: "",
	lastname: "",
	phone: "",
	email: "",
	gender: "",
}
